import PersonIcon from '@mui/icons-material/Person';
import { FormControlLabel, Switch } from '@mui/material';

import { UserCard } from '../../Card/index.js';
import { useTranslation } from '../../../context/TranslationContext.jsx';

import {
  HeaderAvatar,
  HeaderAvatarButton,
  LocalHostToggleRow,
  LocalHostToggles,
  MissingUserName,
  PowerIcon,
  RebootIcon,
  UserMenuActions,
  UserMenuButton,
  UserMenuPopover,
} from './styles';

const HeaderUserMenu = ({
  avatarButtonRef,
  currentUser,
  isOpen,
  isLocalHost,
  localHostToggles,
  onOpenRebootDialog,
  onOpenShutdownDialog,
  onSignOut,
  onToggle,
}) => {
  const { translate } = useTranslation();

  return (
    <>
      <HeaderAvatarButton
        ref={avatarButtonRef}
        onClick={onToggle}
        aria-label={translate('header.userMenu')}
        aria-controls={isOpen ? 'user-card-popover' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : undefined}
        size="small"
      >
        <HeaderAvatar>
          <PersonIcon fontSize="small" />
        </HeaderAvatar>
      </HeaderAvatarButton>

      <UserMenuPopover
        id="user-card-popover"
        open={isOpen}
        onClose={onToggle}
        anchorEl={avatarButtonRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <UserCard
          title={
            currentUser || <MissingUserName>{translate('header.nameIsMissing')}</MissingUserName>
          }
          onSignOut={onSignOut}
          text=""
        >
          <UserMenuActions>
            <UserMenuButton
              startIcon={<RebootIcon />}
              onClick={onOpenRebootDialog}
              variant="outlined"
            >
              {translate('header.RebootDevice')}
            </UserMenuButton>
            <UserMenuButton
              startIcon={<PowerIcon />}
              onClick={onOpenShutdownDialog}
              variant="outlined"
            >
              {translate('header.SwitchOffDevice')}
            </UserMenuButton>
          </UserMenuActions>
        </UserCard>

        {isLocalHost ? (
          <LocalHostToggles>
            {localHostToggles.map(({ key, label, onChange, defaultChecked }) => (
              <LocalHostToggleRow key={key}>
                <FormControlLabel
                  control={<Switch onChange={onChange} defaultChecked={defaultChecked} />}
                  label={label}
                />
              </LocalHostToggleRow>
            ))}
          </LocalHostToggles>
        ) : null}
      </UserMenuPopover>
    </>
  );
};

export default HeaderUserMenu;
